module.exports = __webpack_public_path__ + "img/avatar.7e0a4b2d.png";